'use client';

import { cn } from '@/lib/utils';

import { WithRef } from '@/components/types';

import IconCheckbox from '~/svg/IconCheckbox.svg';
import { useId } from 'react';

const commonStyles = cn(
  'absolute flex items-center h-4 w-4 border rounded-sm bg-neutral-N00 appearance-none checked:bg-transparent checked:border-primary-P99 border-neutral-N20 bg-neutral-N00'
);

export type CheckboxProps = {
  id?: string;
  classNames?: {
    root?: string;
    label?: string;
  };
  label?: React.ReactNode;
  isDisabled?: boolean;
  value: string;
  checked?: boolean;
  error?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Checkbox = ({
  classNames,
  label,
  isDisabled,
  value,
  onChange,
  checked,
  ref,
  error,
  ...props
}: WithRef<HTMLInputElement, CheckboxProps>) => {
  const conditionalClasses = cn(
    commonStyles,
    !!error && 'border-error-E99',
    classNames?.root
  );

  const id = useId();

  return (
    <div
      className='relative flex items-center gap-x-1.5'
      data-tracker-component='checkbox'
    >
      <div>
        <input
          id={id}
          disabled={isDisabled}
          type='checkbox'
          className={cn(conditionalClasses)}
          value={value}
          checked={checked}
          onChange={onChange}
          ref={ref}
          {...props}
        />
        <div>
          <IconCheckbox className='bg-neutral-N00 text-primary-P99 h-4 w-4 rounded-sm' />
        </div>
      </div>
      <label
        htmlFor={id}
        className={cn(
          'text-body-l font-sans leading-normal',
          !!error && 'text-error-E99',
          classNames?.label
        )}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
